import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";

export default interface EventMedium {
  id: string;
  teamId: string;
  taskId: string;
  type: string;
  uploaded: boolean;
  processed: boolean;
  thumbnail: string;
  optimized: string;
  original: string;
  aspectRatio: number;
  score: number;
  isImage: boolean;
  isVideo: boolean;
  rotation: number;
  mirrored: boolean;
}

export function mediumImageStyle(medium?: EventMedium) {
  if (!medium || !medium.isImage) {
    return {};
  }

  return {
    transform: `rotate(${medium.rotation}deg) scaleX(${medium.mirrored ? -1 : 1})`
  };
}

export class EventMediumConverter implements FirestoreDataConverter<EventMedium> {
  toFirestore(medium: EventMedium): DocumentData {
    return medium;
  }

  fromFirestore(snapshot: QueryDocumentSnapshot<DocumentData>, options: SnapshotOptions): EventMedium {
    const data = snapshot.data(options);

    return Object.freeze({
      id: snapshot.id,
      teamId: data.teamId || "",
      taskId: data.taskId || "",
      type: data.type || "",
      uploaded: data.uploaded || false,
      processed: data.processed || false,
      thumbnail: data.thumbnail || "",
      optimized: data.optimized || "",
      original: data.original || "",
      aspectRatio: data.aspectRatio || 1,
      score: data.score || 0,
      rotation: data.rotation || 0,
      mirrored: data.mirrored || false,

      isImage: data.type.split("/")[0] === "image",
      isVideo: data.type.split("/")[0] === "video"
    });
  }
}

export function eventMediumFromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): EventMedium {
  const data = snapshot.data(options);

  return Object.freeze({
    id: snapshot.id,
    teamId: data.teamId || "",
    taskId: data.taskId || "",
    type: data.type || "",
    uploaded: data.uploaded || false,
    processed: data.processed || false,
    thumbnail: data.thumbnail || "",
    optimized: data.optimized || "",
    original: data.original || "",
    aspectRatio: data.aspectRatio || 1,
    score: data.score || 0,
    rotation: data.rotation || 0,
    mirrored: data.mirrored || false,

    isImage: data.type.split("/")[0] === "image",
    isVideo: data.type.split("/")[0] === "video"
  });
}
